export const PHASE_COLORS: Record<string, string> = {
  arrival: "#888",
  plan: "#4a9eff",
  meter: "#4aff6a",
  equipment: "#ffaa4a",
  before: "#ff8aa3",
  scope: "#c79bff",
  panorama: "#9be7ff",
  scan: "#7dd3fc",
  other: "#555",
};

export const MEDIA_ICON: Record<string, string> = {
  photo: "🖼",
  video: "▶",
  panorama_frame: "🌐",
  roomplan_usdz: "🏠",
  roomplan_json: "{ }",
  roomplan_plan_png: "▭",
  roomplan_dxf: "📐",
  glb: "⬡",
  usdz: "⬡",
};
